export default __webpack_public_path__ + "static/media/city_active.0fcc8c52.png";